module.exports = __webpack_public_path__ + "img/right_arrow.3395c9f3.svg";